module.exports = __webpack_public_path__ + "static/media/dot-gray.38f633ad.svg";